import React, { useCallback, useEffect } from "react";
import useCallbackRef from "./useCallBackRef";
import eventEmitter from "services/event.emitter";

export const useEventEmitter = (eventName = "", callback = () => {}) => {
  const callbackRef = useCallbackRef(callback);

  const handleEvent = useCallback(
    (event) => {
      callbackRef.current(event);
    },
    [callbackRef]
  );

  useEffect(() => {
    eventEmitter.on(eventName, handleEvent);
    return () => {
      eventEmitter.off(eventName, handleEvent);
    };
  }, []);
};
